import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

/**
 * Batch 65 — GoHighLevel vertical-industry cluster service links.
 *
 * Every Batch 65 article routes its primary commercial link to
 * /gohighlevel-revops-architect. The answer-first leads in batch65Content.ts
 * embed the link directly, but the lead-swap idempotency guard can drop the
 * lead when the Quick Answer duplicates the lead text. This map is the
 * RELIABLE fallback: `injectBatchServiceLink` (batchContentOptimizer.ts) wraps
 * the first in-body occurrence of each anchor phrase in a
 * /gohighlevel-revops-architect link, so the contextual service link always
 * renders regardless of the lead swap.
 *
 * Anchors are distinctive body phrases (not in the H1) so the link injects
 * into the article body, never the headline.
 */
export const BATCH65_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  "gohighlevel-for-coaches-setup": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /sub-account with no program pipeline is a sub-account the coach outgrows/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-for-med-spa-setup": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /sub-account with no intake gate is a sub-account the clinic cannot defend/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-for-solar-contractors": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /sub-account with no dispatch rule is a sub-account the foreman runs/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-for-insurance-agents": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /sub-account with no renewal rule is a sub-account the agent rekeys/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-for-mortgage-brokers": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /sub-account with no milestone rule is a sub-account the loan officer runs/i,
    label: "hire a GoHighLevel RevOps architect",
  },
};
